import { render, staticRenderFns } from "./WelcomeSection.vue?vue&type=template&id=30c0573e&scoped=true"
import script from "./WelcomeSection.vue?vue&type=script&lang=js"
export * from "./WelcomeSection.vue?vue&type=script&lang=js"
import style0 from "./WelcomeSection.vue?vue&type=style&index=0&id=30c0573e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0573e",
  null
  
)

export default component.exports